/**
 * SupervisorLayout — Responsive wrapper for supervisor routes.
 * On desktop (≥768px), renders children inside the standard Layout.
 * On mobile (<768px), shows the mobile supervisor dashboard only on the
 * dashboard route; all other routes render their normal children.
 */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from './Layout';
import MobileSupervisorDashboard from './MobileSupervisorDashboard';

const MOBILE_BREAKPOINT = 768;

const SupervisorLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_BREAKPOINT);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isDashboardRoute = location.pathname === '/supervisor' || location.pathname === '/supervisor/';

  return (
    <Layout>
      {isMobile && isDashboardRoute ? <MobileSupervisorDashboard /> : children}
    </Layout>
  );
};

export default SupervisorLayout;
